import Text from "../../components/Text";
import { useState, useEffect } from "react";
import { Col, Row, useIsMobile } from "../../components/Flexbox";
import { useSearchParams } from "react-router-dom";
import CreateUser from "../../components/CreateUser";
import EditUser from "../../components/EditUser";
import EditRoles from "../../components/EditRoles";
import CreateRole from "../../components/CreateRole.js";
import Spinner from "../../components/Spinner";
import UsersTable from "../../components/UsersTable";
import RolesTable from "../../components/RolesTable";
import { AccessReqHandler } from "../../scripts/functions/AccessReqHandler.js";
import { useAuth } from "../../scripts/functions/AuthProvider.js";
import { RolesNormalizer } from "../../containers/RolesNormalizer.js";
import { RoleReqHandler } from "../../scripts/functions/RoleReqHandler.js";
import { FLAT_SCHEMA } from "../../scripts/configs/PermissionsConfig.js";
import { PascalCase, SortData} from "../../utils";
import { useTheme } from "../../scripts/functions/ThemeProvider.js";
const HIDE_SCROLLBAR = 'acceso-table-no-scrollbar';
const Acceso = () => {
    const {theme} = useTheme();
    const isMobile = useIsMobile();
    const [activeUser, setActiveUser] = useState(null);
    const [activeRole, setActiveRole] = useState(null);
    const [activeContainer, setActiveContainer] = useState("Usuarios");
    const [searchParams, setSearchParams] = useSearchParams();
    const [mailAction, setMailAction] = useState(false);

    const [isPopupOpen, setIsPopupOpen] = useState(null);

    const {requests, isLoading, users, isUsersLoading, getRequests, createUser, getUsers, updateUser, updateRequest, validateToken, deleteUser} = AccessReqHandler();
    const {permissions, roleMap, roleNameMap, roleReqs, createRole, updateRole, getRoles, getFullSchema, deleteRole, createRoleChangeReq, getRoleChangeReq, updateRoleChangeReq} = RoleReqHandler();
    const {sortedItems, requestSort, getIcon} = SortData(users);
    const {roles} = RolesNormalizer(roleMap, users);
    const rolesData = roles?.map(role => {
        const roleKey = roleMap[role.nombre];
        const schemaInfo = FLAT_SCHEMA[roleKey];
        return {...role, key: roleKey, actions: permissions?.[roleKey] || [], isEditable: schemaInfo?.is_custom === true};
    }) || [];
    const {sortedItems: sortedRoles, requestSort: requestRoleSort, getIcon: getRoleIcon} = SortData(rolesData);
    const {userClaims} = useAuth();

    useEffect(() => {
        const init = async () => {
            const schema = await getFullSchema();
            if (activeContainer === "Usuarios") {
                getRequests();
                getUsers(schema.maps?.roleNameMap);
            } else {     
                getRoles();
                getRoleChangeReq();
            }
        };
        init();
    }, [activeContainer]);

    const refreshAfterAccessApproval = async () => {
        await getRequests();
        await getUsers(roleNameMap);
        closePopup();
    }

    const refreshUsers = async () => {
        await getUsers(roleNameMap);
        closePopup();
    }

    const refreshRoles = async () => {
        await getFullSchema();
        await getRoles();
        await getRoleChangeReq();
        closePopup();
    }

    const handleContainers = (text) => {
        setActiveContainer(text);
    };

    const openPopup = (popup, roleData = null, userData = null) => {
        setIsPopupOpen(popup);
        setActiveRole(roleData);
        setActiveUser(userData)
    }

    const closePopup = () => {
        setIsPopupOpen(null);
    }

    useEffect(() => {
        const token = searchParams.get('token') //Get the token from the URL
        // console.log("Token: ", token);
        if (token && !mailAction && !isLoading) {
            setMailAction(true);
            validateToken(token, true).then(data => {
                if (data) {
                    const {action, email, request_id} = data;
                    // console.log("Data token: ", data)
                    const findRequest = requests.find(req => req.email === email && req.request_id === request_id);
                    // console.log("Name: ", findRequest)
                    if (action === 'approve') {
                        openPopup("CreateUser", null, {name: findRequest.name, email: email, request_id: request_id});
                    } else if (action === 'reject') {
                        updateRequest({mail: email, request_id: request_id, action: 'REJECT'})
                            .then(result => {
                                if (result.success) {
                                    console.log("Solicitud rechazada con éxito!")
                                } else {
                                    console.error("Ocurrió un error al rechazar la solicitud de: ", {email})
                                }
                            })
                    }
                } else {
                    console.error("Error al procesar el token.")
                }

                setSearchParams({}, {replace: true}); //Clean URL params
            })
        }
    }, [searchParams, updateRequest, requests])

    const formatUsers = (enabled, status) => {
        if (enabled === false) return {text: "Deshabilitado", color: theme.Red}

        if (status === 'FORCE_CHANGE_PASSWORD') return {text: "Sin confirmar", color: theme.Lao}

        if (status === 'CONFIRMED') return {text: "Habilitado", color: theme.Lime}

        // console.log(`Status: ${status}  Enabled: ${enabled}`)
        return {text: "Desconocido", color: theme.Blue}
    }

    const handleRoleChange = async (request) => {
        const user = users.find(u => u.name === request.username)

        if (!user) {
            // console.log(`Request user ${request.username} not found`);
            return;
        }

        const data = {
            name: request.username, 
            username: user.username,
            roleKeys: [request.new_role], 
            email: request.email,
            request_id: request.request_id,
            isFromRequest: true //Let EditUser know the change will come from a request
        };

        openPopup("EditUser", null, data);
    }

    const isDark = theme.White !== "#FFFFFF";

    return(
        <Col style={{width:'100%', alignItems:'flex-start', paddingLeft: isMobile ? 16 : 64, paddingRight: isMobile ? 16 : 64, marginTop: 32, paddingBottom: 32, gap: 32, flex: 1, minHeight: 0, boxSizing: 'border-box'}}>
            <style>{`.${HIDE_SCROLLBAR}::-webkit-scrollbar { display: none; }`}</style>
            <Col style={{height: 65, flex:'none', width: '100%', alignItems:'flex-start', justifyContent: 'space-between'}}>
                <Text color={theme.Black} size={21} weight={"extrabold"}>Acceso</Text>
                <Row style={{height: 20, width: '100%', justifyContent: 'space-between', paddingTop: 30}}>
                <Row style={{maxWidth: 206, justifyContent: 'space-between'}}>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={activeContainer === "Usuarios" ? theme.Magenta : theme.Lao} onClick={() => handleContainers("Usuarios")} size={15}>Usuarios</Text>
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={activeContainer === "Roles de permisos" ? theme.Magenta : theme.Lao} onClick={() => handleContainers("Roles de permisos")} size={15}>Roles de permisos</Text>
                </Row>
                <Row style={{height: 20, maxWidth: 206, justifyContent: 'end'}}>
                    {activeContainer === "Usuarios" ? (
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Magenta} onClick={() => openPopup("CreateUser", null, null)} size={15}>Crear usuario</Text>
                    ) : (
                    <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Magenta} onClick={() => openPopup("CreateRole")} size={15}>Crear rol de permisos</Text>
                    )}
                </Row>
                </Row>
            </Col>
            {activeContainer === "Usuarios" && (
                <>
                    <Col style={{width: '100%', flex: 1, minHeight: 0, alignItems:'flex-start'}}>
                        <Text color={theme.Black} size={15} weight={"extrabold"}>Solicitudes de acceso</Text>
                        {isLoading ? 
                            <Col style={{justifyContent: 'center', alignItems: 'center', minHeight: 200, width:'100%'}}>
                                <Spinner theme={theme}/>
                            </Col>
                            :
                            <Col style={{width: '100%', flex: 1, minHeight: 0, overflowY: 'auto', marginTop: 12}}>
                                <Col style={{width: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '1rem'}}>
                                    {requests.length !== 0 ? [...requests].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((sol) => (
                                        <Row key={sol.request_id} style={{width: '100%', justifyContent: 'space-between', alignItems: 'space-between', flex: 'none'}}>
                                            <Text color={theme.ONED} size={15}>{sol.email}</Text>
                                            <Row style={{maxWidth: '140px', justifyContent: 'space-between'}}>
                                                <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={() => updateRequest({mail: sol.email, request_id: sol.request_id, action: 'REJECT'})} color={theme.SEVENB} size={15}>Rechazar</Text>
                                                <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={() => openPopup("CreateUser", null, {name: sol.name, email: sol.email, request_id: sol.request_id})} color={theme.Magenta} size={15}>Aprobar</Text>
                                            </Row>
                                        </Row>
                                    )) : (
                                        <Row style={{width: '100%', alignItems: 'center', flex: 'none'}}>
                                            <Text weight="medium" size={24} color={theme.SEVENB} style={{flex: 1, height: 20, textAlign: 'center'}}>No hay solicitudes pendientes</Text>
                                        </Row>
                                    )}
                                </Col>
                            </Col>
                        }
                    </Col>
                    <Col style={{width: '100%', alignItems:'flex-start', flex: 1.5, minHeight: 0}}>
                        <Text color={theme.Black} size={15} weight={"extrabold"}>Usuarios</Text>
                        <UsersTable theme={theme} users={sortedItems} isLoading={isUsersLoading} requestSort={requestSort} getIcon={getIcon} formatStatus={formatUsers} onEdit={(user) => openPopup("EditUser", null, user)}/>
                    </Col>
                </>
            )}
            {activeContainer === "Roles de permisos" && (
                <>
                    <Col style={{width: '100%', flex: 1, minHeight: 0, alignItems:'flex-start'}}>
                        <Text color={theme.Black} size={15} weight={"extrabold"}>Solicitudes de cambio de rol</Text>
                       <Col style={{width: '100%', flex: 1, minHeight: 0, overflowY: 'auto', marginTop: 12}}>
                            <Col style={{width: '100%', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '1rem'}}>
                            {roleReqs.length !== 0 ? (roleReqs.map(cambio => (
                                <Row style={{width: '100%', justifyContent: 'space-between', alignItems: 'space-between', flex: 'none'}}>
                                    <Text weight="medium" size={15} color={theme.SEVENB} style={{flex: 1, height: 20}}>{cambio.email}</Text>
                                    <Text weight="medium" size={15} color={theme.SEVENB} style={{flex: 1, height: 20}}>{`${PascalCase(cambio.current_role)} → ${PascalCase(cambio.new_role)}`}</Text>
                                    <Row style={{maxWidth: '140px', justifyContent: 'space-between'}}>
                                        <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.SEVENB} onClick={() => updateRoleChangeReq({mail: cambio.email, request_id: cambio.request_id, action: 'REJECT', admin_mail: userClaims.email})} size={15}>Rechazar</Text>
                                        <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Magenta} onClick={() => handleRoleChange(cambio)} size={15}>Aprobar</Text>
                                    </Row>
                                </Row>
                            ))) : (
                                <Row style={{width: '100%', alignItems: 'center', flex: 'none'}}>
                                    <Text weight="medium" size={24} color={theme.SEVENB} style={{flex: 1, height: 20, textAlign: 'center'}}>No hay solicitudes pendientes</Text>
                                </Row>
                            )}
                            </Col>
                        </Col>
                    </Col>
                    <Col style={{width: '100%', flex: 1.5, minHeight: 0, alignItems:'flex-start'}}>
                        <Text color={theme.Black} size={15} weight={"extrabold"}>Roles de permisos</Text>
                        <RolesTable theme={theme} roles={sortedRoles} isLoading={isUsersLoading} requestSort={requestRoleSort} getIcon={getRoleIcon} onEdit={(role) => openPopup("EditRoles", role)}/>
                    </Col>
                </>
            )}
            
            {isPopupOpen === "CreateUser" && <CreateUser theme={theme} onClose={closePopup} roles={roleMap} initialData={activeUser ? {mail: activeUser.email, name: activeUser.name, request_id: activeUser.request_id} : {mail: "", name: ""}} createUser={createUser} updateRequest={updateRequest} onSuccess={activeUser?.request_id ? refreshAfterAccessApproval : refreshUsers} isDark={isDark}/>}
            {isPopupOpen === "CreateRole" && <CreateRole theme={theme} onClose={closePopup} createRole={createRole} roleMap={roleMap} users={users} onSuccess={refreshRoles} isDark={isDark}/>}
            {isPopupOpen === "EditUser" && <EditUser theme={theme} activeUser={activeUser} onClose={closePopup} claims={userClaims} roleNameMap={roleNameMap} roles={roleMap} updateUser={updateUser} deleteUser={deleteUser} onSuccess={refreshUsers} changeReq={createRoleChangeReq} resolveRequest={updateRoleChangeReq} isDark={isDark}/>}
            {isPopupOpen === "EditRoles" && <EditRoles theme={theme} activeRole={activeRole} onClose={closePopup} claims={userClaims} updateRole={updateRole} deleteRole={deleteRole} onSuccess={refreshRoles} isDark={isDark}/>}
        </Col>
    )
};

export default Acceso;